/**
 * @generated SignedSource<<c760a99acd041ba5cd816d7e70a8c143>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type YesNoBlank = "blank" | "no" | "yes";
export type SurveyEmployeeInput = {
  attrYears: ReadonlyArray<string>;
  birthday?: string | null | undefined;
  ieNm: string;
  indvTin: string;
};
export type EmployeeWithoutTinInput = {
  birthday?: string | null | undefined;
  ieNm: string;
};
export type employmentSpecialRelationshipsPastMutation$variables = {
  hasSpecialRelationshipsInThePast?: YesNoBlank | null | undefined;
  isCompleted: boolean;
  specialRelationshipsCurrently?: ReadonlyArray<EmployeeWithoutTinInput> | null | undefined;
  specialRelationshipsInThePast?: ReadonlyArray<SurveyEmployeeInput> | null | undefined;
  surveyAnswerId: string;
};
export type employmentSpecialRelationshipsPastMutation$data = {
  readonly upsertEmploymentAnswer: {
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type employmentSpecialRelationshipsPastMutation = {
  response: employmentSpecialRelationshipsPastMutation$data;
  variables: employmentSpecialRelationshipsPastMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasSpecialRelationshipsInThePast"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCompleted"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "specialRelationshipsCurrently"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "specialRelationshipsInThePast"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "surveyAnswerId"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "hasSpecialRelationshipsInThePast",
        "variableName": "hasSpecialRelationshipsInThePast"
      },
      {
        "kind": "Variable",
        "name": "isCompleted",
        "variableName": "isCompleted"
      },
      {
        "kind": "Variable",
        "name": "specialRelationshipsCurrently",
        "variableName": "specialRelationshipsCurrently"
      },
      {
        "kind": "Variable",
        "name": "specialRelationshipsInThePast",
        "variableName": "specialRelationshipsInThePast"
      },
      {
        "kind": "Variable",
        "name": "surveyAnswerId",
        "variableName": "surveyAnswerId"
      }
    ],
    "concreteType": "RefundUserPutSurveyAnswerOutput",
    "kind": "LinkedField",
    "name": "upsertEmploymentAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "employmentSpecialRelationshipsPastMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "employmentSpecialRelationshipsPastMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "471aaecadcf313e0710a6f0d6d06f533",
    "id": null,
    "metadata": {},
    "name": "employmentSpecialRelationshipsPastMutation",
    "operationKind": "mutation",
    "text": "mutation employmentSpecialRelationshipsPastMutation(\n  $surveyAnswerId: String!\n  $isCompleted: Boolean!\n  $hasSpecialRelationshipsInThePast: YesNoBlank\n  $specialRelationshipsInThePast: [SurveyEmployeeInput!]\n  $specialRelationshipsCurrently: [EmployeeWithoutTinInput!]\n) {\n  upsertEmploymentAnswer(surveyAnswerId: $surveyAnswerId, isCompleted: $isCompleted, hasSpecialRelationshipsInThePast: $hasSpecialRelationshipsInThePast, specialRelationshipsInThePast: $specialRelationshipsInThePast, specialRelationshipsCurrently: $specialRelationshipsCurrently) {\n    result\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "91d70f5dfa5b487f4cb24913aa13aa77";

export default node;
